// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// ✅ RESTORE this backend
const backend = {
  type: 'backend',
  read: async (language, _namespace, callback) => {
    try {
      const res = await fetch(`/locales/${language}/common.json`);
      const data = await res.json();
      callback(null, data);
    } catch (e) {
      callback(e, null);
    }
  }
};

let initialized = false;

export async function ensureI18n() {
  if (initialized) return i18n;
  await i18n
    .use(backend)          // ✅ put it back so JSON loads
    .use(initReactI18next)
    .init({
      lng: 'en',
      fallbackLng: 'en',
      interpolation: { escapeValue: false }
    });
  initialized = true;
  return i18n;
}

// Keep alias if index.js imports initI18n
export const initI18n = ensureI18n;

export default i18n;
